import * as yup from 'yup';
import { error } from '../../validation/text';

const emailValidation = yup
  .string()
  .lowercase()
  .required(error.required)
  .email(error.email)
  .max(250, error.below250);

const companyValidation = yup
  .string()
  .required(error.required)
  .max(250, error.below250);

const contentValidation = yup
  .string()
  .required(error.required)
  .max(2000, error.below2000);

const departmentValidation = yup
  .string()
  .required(error.required)
  .max(250, error.below250);

const nameValidation = yup
  .string()
  .required(error.required)
  .max(250, error.below250);

const telValidation = yup
  .string()
  .matches(/^[0-9-]*$/, error.tel)
  .required(error.required)
  .max(20, error.below20);

const contactTypeValidation = yup.number().required(error.requiredSelect);

export const contactSchema = yup.object().shape({
  company: companyValidation,
  content: contentValidation,
  department: departmentValidation,
  email: emailValidation,
  name: nameValidation,
  tel: telValidation,
  type: contactTypeValidation
});

export const productContactSchema = yup.object().shape({
  company: companyValidation,
  content: contentValidation,
  department: departmentValidation,
  email: emailValidation,
  name: nameValidation,
  tel: telValidation
});
